// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"137":"revew","328":"admin","535":"login","757":"game","908":"history","983":"report"}[chunkId] || chunkId) + "-legacy." + {"137":"af997789","233":"a89ba485","328":"da0e3154","535":"4439284a","757":"0315693c","767":"49cddb1b","908":"566ceb77","983":"a6e67e8c"}[chunkId] + ".js";
};